module.exports = __webpack_public_path__ + "assets/img/ic-filter.34814b41.svg";